import { IProduct } from './../interfaces/IProduct';
import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  IProductCategory,
  IProductResponse,
  IProductFilter,
} from '../interfaces/IProduct';
import { ClientCreateThirdStep } from '../models/IClient/IClient';
import { API_BASE_URL } from '../helpers/common';
import { IPaginationResponse } from 'interfaces/responces/IPagination.response';
import { IProductItem } from 'interfaces/IProductItem';

export const itemsApi = createApi({
  reducerPath: 'itemsApi',
  tagTypes: ['Item'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      token && headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    /*
     * @deprecated use getItemsList instead or categoriesApi
     */
    getItemsCategories: build.query<IProductCategory[], string>({
      transformResponse: (response: { data: IProductCategory[] }) =>
        response.data,
      query: () => ({
        url: '/products/list',
        method: 'GET',
      }),
    }),
    getProductItems: build.query<
      IPaginationResponse<IProduct[]>,
      IProductFilter
    >({
      transformResponse: (response: {
        data: IPaginationResponse<IProduct[]>;
      }) => response.data,
      query: ({ page, search, category }) => ({
        url: '/product-items/list',
        method: 'GET',
        params: {
          page,
          search,
          category_id: category,
        },
      }),
      providesTags: () => ['Item'],
    }),
    getProductItemById: build.query<
      IProductItem,
      number | string
    >({
      transformResponse: (response: { data: IProductItem }) => response.data,
      query: (id) => ({
        url: `/product-items/${id}`,
        method: 'GET',
      }),
    }),
    getItemsShortList: build.query<IProduct[], any>({
      transformResponse: (response: { data: IProduct[] }) => response.data,
      query: () => ({
        url: '/products/short-list',
        method: 'GET',
      }),
      providesTags: () => ['Item'],
    }),
    createProduct: build.mutation<IProduct, any>({
      transformResponse: (response: { data: IProduct }) => response.data,
      query: (newProduct) => ({
        url: '/products/create',
        method: 'POST',
        body: newProduct,
      }),
      invalidatesTags: ['Item'],
    }),
    createProductItem: build.mutation<IProductItem, any>({
      transformResponse: (response: { data: IProductItem }) => response.data,
      query: (newProductItem) => ({
        url: '/product-items/create',
        method: 'POST',
        body: newProductItem,
      }),
    }),
    updateProductItem: build.mutation<IProduct, { item: any; id: any }>({
      transformResponse: (response: { data: IProduct }) => response.data,
      query: (data) => ({
        url: `/product-items/${data.id}`,
        method: 'PATCH',
        body: data.item,
      }),
      invalidatesTags: ['Item'],
    }),
    updateItemsPricing: build.mutation<
      any,
      { clientId: string; data: ClientCreateThirdStep }
    >({
      transformResponse: (response: { data: IProduct }) => response.data,
      query: ({ clientId, data }) => {
        return {
          url: `clients/${clientId}/pricing`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['Item'],
    }),
    deleteItem: build.mutation<IProduct, number>({
      query: (itemId) => {
        return {
          url: `/items/${itemId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['Item'],
    }),
    // exportItems: build.query<
    //   any,
    //   { search: string; ids: number[]; category_id: string }
    // >({
    //   query: ({ search, ids, category_id }) => {
    //     return {
    //       url: `/api/items/export`,
    //       method: "GET",
    //       params: {
    //         search,
    //         ids,
    //         category_id,
    //       },
    //     };
    //   },
    // }),
  }),
});
